import React from "react";

const AboutLabel = (props) => (
    <div>
        <h4>{props.body_text}</h4>
    </div>
);

export default AboutLabel;